import React, { useState, useEffect, Suspense } from 'react';
import { ServiceType } from '../types';

// Lazy load the heavy 3D component
const ThreeBackground = React.lazy(() => import('./ThreeBackground'));

// The static CSS fallback (same as App.tsx)
// REMOVED GRADIENT to match the solid black of the 3D scene, preventing the "flick"
const BackgroundFallback = () => (
    <div className="fixed top-0 left-0 w-full h-[100svh] z-0 bg-[#050505]">
        {/* Solid black placeholder */}
    </div>
);

interface DeferredBackgroundProps {
    activeService: ServiceType;
}

const DeferredBackground: React.FC<DeferredBackgroundProps> = ({ activeService }) => {
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        // Wait 2.5 seconds after mount (page load) before triggering the 3D download
        // This allows the browser to prioritize LCP (text/images) and finish the main thread work.
        const timer = setTimeout(() => {
            setShouldLoad(true);
        }, 2500);

        return () => clearTimeout(timer);
    }, []);

    if (!shouldLoad) {
        return <BackgroundFallback />;
    }

    return (
        <Suspense fallback={<BackgroundFallback />}>
            <ThreeBackground activeService={activeService} />
        </Suspense>
    );
};

export default DeferredBackground;